import React, { useState } from "react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { Button, Dropdown, DropdownButton, Modal } from "react-bootstrap";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";


import { Common, DeletePupilById, SUCCESS } from "../../../helper";
import { EditPupil } from "./";
import { isEmptyObject } from "../../../util";
import * as commonApi from "../../../api/commonApi";
import { success } from "../../Shared";

import "../../../assets/stlyes/Modals.css";

const Action = (props) => {
  const { pupilId, getData, foreName, surName } =props;
  const [IsEditPupil, setEditPupil] = useState(false);
  const [isPupilId, setIsPupilId] = useState("");
  const MySwal = withReactContent(Swal);

  const DeletePupil = () => {
    MySwal.fire({
      title: Common.Delete,
      text: DeletePupilById( foreName, surName ),
      type: "success",
      showCancelButton: true,
      confirmButtonText: Common.DeletePupil,
    }).then((result) => {
      if (result.value) {
        confirmDeletePupil();
      } else {
        MySwal.fire(Common.NotDeleted);
      }
    });
  };

  const confirmDeletePupil = async () => {
    const deletePupil = await commonApi.deletePupil({
      id: pupilId,
      active:false
    });
    if (!isEmptyObject(deletePupil)) {
      success(SUCCESS.PUPIL_DELETED_SUCCESSFULLY)
      getData();
    }
  };

  return (
    <>
      <DropdownButton as={ButtonGroup} id="dropdown-variants-Secondary" title={Common.Actions}>
        <Button className="modal-button d-flex justify-content-start" type="button" onClick={() => { setIsPupilId(pupilId); setEditPupil(true); }}>
          <ModeEditOutlineOutlinedIcon />&nbsp;{Common.EditPupil}
        </Button>

        <Dropdown.Divider />
        <Button className="modal-button-danger d-flex justify-content-start" type="button" onClick={DeletePupil}>
          <RemoveCircleOutlineOutlinedIcon />&nbsp;{Common.RemovePupil}
        </Button>
      </DropdownButton>
      <Modal show={IsEditPupil} onHide={() => { setEditPupil(false); }} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title >
            {Common.EditPupil}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditPupil isPupilId={isPupilId} setEditPupil={setEditPupil} getData={getData} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

export { Action };